import { Navigate, Outlet } from "react-router-dom";
import authService from "../redux/auth/authService";
import { canAccessSuperAdminFeatures } from "../constants/adminAccess";

const SuperAdminRoute = () => {
  const aumUserId = authService.getAumUserId();
  return canAccessSuperAdminFeatures(aumUserId) ? (
    <Outlet />
  ) : (
    <Navigate to="/dashboard" replace />
  );
};

export default SuperAdminRoute;
